module.exports = __webpack_public_path__ + "img/no4.cd8e7632.png";